import '@sparta.global.vendors/handlebars';
import { tabNavigation } from '@sparta.global.helpers/tab-navigation-helper/dist/es6.js';

/**
 * Constant for storing message strings.
 */
const STRINGS = {
  NO_TAB_JCR_ERROR: 'No tab JCR objects provided to helper-tab.'
};

/**
   * Pieces together all the HTML elements needed to make a tab set.
   * @param {object} partials - Object of partials provided by module JCR.
   * @param {object} jcr - JSON object used to build the tabHelper.
   * @returns {Node} `Handlebars.SafeString` version of `spa-tab__container` element.
   */
function tabStandard(partials, jcr, ...args) {
  if (!jcr) {
    throw new Error(STRINGS.NO_TAB_JCR_ERROR);
  }

  // Set partials
  const getPartials = partials || {};

  // set custom options
  const getOptions = jcr;
  getOptions.type = 'standard';
  getOptions.level = 'level' in getOptions ? getOptions.level : '2';

  // get data
  const getData = getOptions.isVue ? args : Array.prototype.slice.call(args, 0, -1);

  // use the tabNavHelper helper and feed in any standard tab specific options
  return tabNavigation(getPartials, getOptions, ...getData);
}
tabStandard.functionName = "tabStandard";

export { tabStandard };
